import {RequestForm_FieldTreatAs, RequestFormFieldType} from "../../../../app/tools/request-forms2/const/const"
import FieldConfig from "../../../fields3/proto/field-config"
import FieldProto from "../../../fields3/proto/field-proto"
import FieldsFactory from "../../../fields3/fields-factory"
import {FieldType} from "../../../fields3/field-type"

export type RequestFormFieldConfig = {

    // id - NE DELAEM

    type            : RequestFormFieldType // form field type (system, custom, form)

    taskFieldId?    : string        // i.e. 'title', 'assignToUserId or 'ABC123' field id from gd.fields.task (REQUIRED for system or custom type)
    formFieldConfig?: FieldConfig   // used for form fields Field3 config (REQUIRED for form type):

    field?          : FieldProto

    label           : string        // form field label (REQUIRED)
    description     : string        // form field description
    isRequired      : boolean       // is form field required to be filled for form to be submitted

    isMandatory?    : boolean       // field should present in the list and can't be deleted

    treatAs?        : RequestForm_FieldTreatAs  // special field marker
}

// const debug = "RequestFormField"
const debug = false

export default class RequestFormField implements RequestFormFieldConfig {
    type                : RequestFormFieldType // form field type (system, custom, form)

    taskFieldId?        : string      // i.e. 'title', 'assignToUserId or 'ABC123' field id from gd.fields.task (REQUIRED for system or custom type)
    _formFieldConfig?   : FieldConfig   // used for form fields Field3 config (REQUIRED for form type):

    field?              : FieldProto

    label               : string        // form field label (REQUIRED)
    description         : string        // form field description
    isRequired          : boolean       // is form field required to be filled for form to be submitted

    isMandatory         : boolean       // field should present in the list and can't be deleted | ?? like TaskTitle ?

    treatAs?            : RequestForm_FieldTreatAs   // special field marker

    constructor(data: RequestFormFieldConfig) {
        this.type               = _.get(data, 'type', RequestFormFieldType.FORM)
        this.taskFieldId        = _.get(data, 'taskFieldId', undefined)
        this.formFieldConfig    = _.get(data, 'formFieldConfig', undefined)

        this.label              = _.get(data, 'label', '')
        this.description        = _.get(data, 'description', '')
        this.isRequired         = _.get(data, 'isRequired', false)

        this.isMandatory        = _.get(data, 'isMandatory', false)
        this.treatAs            = _.get(data, 'treatAs', undefined)

        this._updateField()
    }

    get formFieldConfig() {
        return this._formFieldConfig
    }

    set formFieldConfig(formFieldConfig:any) {
        if (!formFieldConfig) return

        // pick only significant parameters and leave all the rest
        // otherwise there will be a lot of unnecessary parameters from FieldProto
        const config:any = {
            fieldId     : formFieldConfig.fieldId,
            type        : formFieldConfig.type,
            label       : formFieldConfig.label,
            isRequired  : formFieldConfig.isRequired,
        }

        switch (formFieldConfig.type) {
            case FieldType.NUMBER       :
            case FieldType.PERCENTAGE   :
                config.decimalPlaces = formFieldConfig.decimalPlaces
                break

            case FieldType.CURRENCY     :
                config.decimalPlaces    = formFieldConfig.decimalPlaces
                config.symbolId         = formFieldConfig.symbolId
                break

            case FieldType.DROPDOWN   :
            case FieldType.MULTISELECT   :
                config.options = formFieldConfig.options
                break

            case FieldType.RATING   :
                config.scale = formFieldConfig.scale
                break
        }

        this._formFieldConfig = config
    }

    get showTreatAs() {
        switch (this.field?.type) {
            case FieldType.STRING:
            case FieldType.EMAIL:
            case FieldType.PHONE:
                return true
        }

        return false
    }

    _updateField = () => {
        if (this.taskFieldId) {
            const field = gd.fields.task.get(this.taskFieldId)
            const taskFieldConfig = field.toJson()
            taskFieldConfig.isCustom        = field.isCustom
            taskFieldConfig.noValueOption   = false
            taskFieldConfig.showMenuMore    = false
            this.field  = FieldsFactory.get(taskFieldConfig)
        } else if (this.formFieldConfig) {

            // field label, description and isRequired should match RequestFormField
            if (this.formFieldConfig) {
                this.formFieldConfig.label          = this.label
                this.formFieldConfig.description    = this.description
                this.formFieldConfig.isRequired     = this.isRequired
            }

            this.field  = FieldsFactory.get(this.formFieldConfig)
        }
    }

    applyDelta(data:any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            if (key === 'type') return

            debug && console.log(debug, "applyDelta key=", key, "value=", value)

            // @ts-ignore
            this[key] = value
            isChanged = true
        })

        this._updateField()

        return isChanged
    }

    toJSON(): JSONObject {
        let res: JSONObject = {
            type            : this.type,
            label           : this.label,
            description     : this.description,
            isRequired      : this.isRequired,
            isMandatory     : this.isMandatory,
            treatAs         : this.treatAs,
        }

        if (this.taskFieldId)       res.taskFieldId     = this.taskFieldId
        if (this.formFieldConfig)   res.formFieldConfig = this.formFieldConfig as any

        return res
    }
}